import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "../../components/Loader";
import { makeStyles } from "@material-ui/core/styles";
import { getApi } from "../../services/api";
import { DISTRICTS } from "../../configs/urls";

const useStyles = makeStyles((theme) => ({
  whiteBg: {
    width: "80%",
    margin: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
}));

export default function Districts() {
  const classes = useStyles();
  const [isRequesting, setIsRequestig] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [params, setParams] = useState({ page: 0, size: 10, state_id: 1 });
  const [totalDistrictsCount, setTotalDistrictsCount] = useState(0);

  useEffect(() => {
    fetchDistricts(true);
  }, []); //eslint-disable-line

  const fetchDistricts = (isInitialLoad) => {
    setIsRequestig(true);
    getApi(DISTRICTS, params)
      .then(
        (res) => {
          if (isInitialLoad) setTotalDistrictsCount(res.meta.total);

          const data = res.data || [];
          const newDistrictsList = [...districts, ...data];

          setDistricts(newDistrictsList);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const renderDistricts = () => (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "10%" }}>Sr. No.</TableCell>
            <TableCell>Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {districts.map((district, idx) => (
            <TableRow key={idx}>
              <TableCell component="th">{idx + 1}</TableCell>
              <TableCell component="th" scope="row">
                {district.name}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {districts.length < totalDistrictsCount && (
        <Grid container justify="center" style={{ padding: 20 }}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={() => loadMoreDistricts()}
          >
            Load More
          </Button>
        </Grid>
      )}
    </TableContainer>
  );

  const loadMoreDistricts = () => {
    setParams({ ...params, page: (params.page += 1) });
    fetchDistricts();
  };

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              Districts
            </Typography>
          </Grid>
          {districts.length ? (
            renderDistricts()
          ) : (
            <Box
              fontSize="h6.fontSize"
              m={1}
              p={{ xs: 2, sm: 2, md: 2 }}
              style={{ textAlign: "center" }}
            >
              No District Found
            </Box>
          )}
        </GridItem>
      </GridContainer>
    </div>
  );
}
